/* SORAMI — Judge.me review form, the parts that need the DOM.

   snippets/sorami-judgeme-boot.liquid does the settings work before the widget
   builds itself. This file handles what can only be done once the modal markup
   exists, and it waits for that markup rather than assuming it is there: the
   modal is built by the widget script, which loads asynchronously.

   1. The anonymous option goes. Judge.me has no setting for it, so the control
      is removed from the form outright — not just hidden — so nothing can
      submit it. CSS hides it too, in case this file is slow to arrive.

   2. Failed submissions become visible. Judge.me posts the review to
      /api/v1/reviews and, if that call fails, catches the error, logs it and
      re-enables the button with nothing on screen. A shopper reads that as the
      form having done nothing, presses the button again, and goes round the
      same dead end. We watch that one request and put the failure on screen,
      with the wording a person can act on. */

(function () {
  var MODAL = '.jdgm-write-review-modal';
  var ERROR_CLASS = 'sorami-jm-error';

  /* ---------- 1. drop the anonymous checkbox ---------- */
  function removeAnonymous(modal) {
    var box = modal.querySelector('#jdgm-anonymous-checkbox');
    if (!box) return;
    box.checked = false;
    var label = box.closest('.jdgm-write-review-modal__checkbox-label') || box.parentElement;
    if (label && label.parentNode) label.parentNode.removeChild(label);
  }

  /* Judge.me rebuilds pages as the shopper moves through the form, so watch
     rather than run once. */
  function watch(modal) {
    removeAnonymous(modal);
    var mo = new MutationObserver(function () { removeAnonymous(modal); });
    mo.observe(modal, { childList: true, subtree: true });
  }

  function whenModal(fn) {
    var found = document.querySelector(MODAL);
    if (found) { fn(found); return; }
    var mo = new MutationObserver(function () {
      var m = document.querySelector(MODAL);
      if (!m) return;
      mo.disconnect();
      fn(m);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 2. say something when the submit fails ---------- */
  function clearError() {
    var old = document.querySelector('.' + ERROR_CLASS);
    if (old && old.parentNode) old.parentNode.removeChild(old);
  }

  function showError(status) {
    var modal = document.querySelector(MODAL);
    if (!modal) return;
    clearError();

    var text;
    if (status === 0) {
      text =
        'Your review could not be sent — the connection dropped. ' +
        'Check you are online and press the button again.';
    } else if (status === 429) {
      text =
        'That is one review too many for now. ' +
        'Give it a few minutes and try again.';
    } else if (status === 422) {
      text =
        'Something in the form was not accepted. ' +
        'Check the rating and your review text, then send it again.';
    } else {
      text =
        'Your review could not be saved just now (error ' + status + '). ' +
        'Please try again in a moment — if it keeps happening, email us and we will add it for you.';
    }

    var p = document.createElement('p');
    p.className = ERROR_CLASS;
    p.setAttribute('role', 'alert');
    p.textContent = text;

    var nav = modal.querySelector('.jdgm-write-review-modal__navigation');
    if (nav && nav.parentNode) {
      nav.parentNode.insertBefore(p, nav);
    } else {
      (modal.querySelector('.jdgm-write-review-modal__content') || modal).appendChild(p);
    }
    p.scrollIntoView({ block: 'nearest' });
  }

  function hookRequests() {
    var XHR = window.XMLHttpRequest;
    if (!XHR || !XHR.prototype || XHR.prototype.__soramiReviewHook) return;

    var open = XHR.prototype.open;
    XHR.prototype.open = function (method, url) {
      this.__soramiReviewPost =
        String(method).toUpperCase() === 'POST' && /\/api\/v1\/reviews\b/.test(String(url));
      return open.apply(this, arguments);
    };

    var send = XHR.prototype.send;
    XHR.prototype.send = function () {
      if (this.__soramiReviewPost) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 300) clearError();
          else showError(this.status);
        });
      }
      return send.apply(this, arguments);
    };

    XHR.prototype.__soramiReviewHook = true;
  }

  hookRequests();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenModal(watch); });
  } else {
    whenModal(watch);
  }
})();
